import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { CallToActionType } from "@omni/types/api/cart/bff/shared/enums/callToActionType.enum";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { useEffect } from "react";

import ChangeStore from "@/components/CallToActions/ChangeStore/changeStore.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import { CTAActions } from "@/redux/modules/api/data/cart/@types/cart.types";
import {
    APIStatus,
    updateStoreAndDeliveryType
} from "@/redux/modules/api/data/cart/cart.module";
import { translateWithoutContext } from "@/redux/modules/value/translations/translations.helpers";
import { TApiAction } from "@/redux/store.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    stores: Array<string>;
    productParams: Array<string>;
    product: CartItem | null;
};

const ChangeStoreAndCncAction = ({
    stores = [],
    product,
    productParams: _productParams = []
}: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading, addMessage } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (stores.length === 0) {
            addMessage(
                CallToActionType.CHANGE_STORE,
                translateWithoutContext("general.cta.changeStore.noStores")
            );
        }
    }, [stores.length]);

    const onChangeStore = (shopId: string) => {
        setLoading(true);
        dispatch(
            updateStoreAndDeliveryType(
                DeliveryType.ClickAndCollect,
                shopId,
                product?.sku!
            )
        ).then((action: TApiAction) => {
            if (action.type === APIStatus.SUCCESS) {
                closeDialog();
            }
        });
    };

    return (
        <ChangeStore
            onChangeStore={onChangeStore}
            stores={stores}
            product={product}
        />
    );
};

const changeStoreAndCnC = (product: CartItem | null, action: CTAActions) => {
    const stores = action.parameters;

    return (
        <ChangeStoreAndCncAction
            stores={stores}
            product={product}
            productParams={action.productParameters}
        />
    );
};

export default changeStoreAndCnC;
